<span class="ribbon"></span>

<div class="header">
    <p class="title">{{ name() }}</p>
    <div class="price-container">
        @if (price() === 0) {
            free
        } @else {
            <span>$</span>
            {{ price() }}
            <span>/{{ period() }}</span>
        }
    </div>
</div>

<div>
    <ul class="lists">
        @for (benefit of benefits(); track benefit) {
            <li class="list">
                <i class="pi pi-check-circle text-green-500 mr-2"></i>
                <p>{{ benefit }}</p>
            </li>
        }
    </ul>
</div>

<div class="button-container">
    @if (isActionButtonVisible()) {
        <p-button
            class="action-button"
            type="button"
            [loading]="isActionButtonLoading()"
            [label]="actionButtonLabel()"
            [severity]="'contrast'"
            (onClick)="actionButtonClick.emit($event)" />
    }
</div>
